@if (show) {
  <div class="alert alert-warning has-icon">
    <div class="alert-icon"><i class="fas fa-database"></i></div>
    <ul class="small">
      <li>Context: BLL is <strong>{{this.app}}</strong> on <strong>{{this.database}}</strong>; app environment is <strong>{{ prod ? 'Prod' : 'NOT Prod'}}</strong>; User {{this.userId}}; Pid {{this.pid}}</li>
      @if (!!this.nowOverride) {
        <li>Now Override: <strong>{{this.nowOverride}}</strong> (for implemented business rules only, not token-related logic)</li>
      }
      <li>Token: Expires in {{this.expiresIn}} sec; Refreshable for {{this.refreshableFor}} sec</li>
      <li>State: {{this.loginState}}; Token: {{this.tokenState}}; Spoofing: Spoofer is {{this.spoofer}}; May Spoof is {{this.maySpoof}} </li>
      <li>API Path: {{this.apiUrl}}</li>
      <li>SSO Path: {{this.ssoUrl}}</li>
      <li>Loggedin User: {{this.auth.loggedInUser$ | async}} ({{this.audiences}})</li>
      <li><a href="/styleguide">Style Guide</a></li>
    </ul>
    <div class="small">
      <b>LogCategory: </b> @for (item of logCategoryValues; track item; let i = $index) {
      <label>
        <input type="checkbox" [checked]="item.checked" (change)="updateSelection(item, 'Category' )">
        {{item.name}}; &nbsp;
      </label>
      } <span><button (click)="updateAll( 'Category', true )">All</button> <button (click)="updateAll( 'Category', false )">None</button> Result: {{ this.getValue(this.logCategoryValues) }}</span>
    </div>
    <div class="small">
      <b>LogCoreComponent: </b> @for (item of logCoreComponentValues; track item; let i = $index) {
      <label>
        <input type="checkbox" [checked]="item.checked" (change)="updateSelection(item, 'CoreComponent' )">
        {{item.name}}; &nbsp;
      </label>
      } <span><button (click)="updateAll( 'CoreComponent', true )">All</button> <button (click)="updateAll( 'CoreComponent', false )">None</button> Result: {{this.getValue(this.logCoreComponentValues) }}</span>
    </div>
    <div class="small">
      <b>logCoreService: </b> @for (item of logCoreServiceValues; track item; let i = $index) {
      <label>
        <input type="checkbox" [checked]="item.checked" (change)="updateSelection(item, 'CoreService' )">
        {{item.name}}; &nbsp;
      </label>
      } <span><button (click)="updateAll( 'CoreService', true )">All</button> <button (click)="updateAll( 'CoreService', false )">None</button> Result: {{this.getValue(this.logCoreServiceValues) }}</span>
    </div>
    <div class="small">
      <b>logDirective: </b> @for (item of logDirectiveValues; track item; let i = $index) {
      <label>
        <input type="checkbox" [checked]="item.checked" (change)="updateSelection(item, 'Directive' )">
        {{item.name}}; &nbsp;
      </label>
      } <span><button (click)="updateAll( 'Directive', true )">All</button> <button (click)="updateAll( 'Directive', false )">None</button> Result: {{this.getValue(this.logDirectiveValues) }}</span>
    </div>
    <div class="small">
      <b>logPage: </b> @for (item of logPageValues; track item; let i = $index) {
      <label>
        <input type="checkbox" [checked]="item.checked" (change)="updateSelection(item, 'Page' )">
        {{item.name}}; &nbsp;
      </label>
      } <span><button (click)="updateAll( 'Page', true )">All</button> <button (click)="updateAll( 'Page', false )">None</button> Result: {{this.getValue(this.logPageValues) }}</span>
    </div>
    <div class="small">
      <b>logService: </b> @for (item of logServiceValues; track item; let i = $index) {
      <label>
        <input type="checkbox" [checked]="item.checked" (change)="updateSelection(item, 'Service' )">
        {{item.name}}; &nbsp;
      </label>
      } <span><button (click)="updateAll( 'Service', true )">All</button> <button (click)="updateAll( 'Service', false )">None</button> Result: {{this.getValue(this.logServiceValues) }}</span>
    </div>
    <div class="small">
      <b>logWidget: </b> @for (item of logWidgetValues; track item; let i = $index) {
      <label>
        <input type="checkbox" [checked]="item.checked" (change)="updateSelection(item, 'Widget' )">
        {{item.name}}; &nbsp;
      </label>
      } <span><button (click)="updateAll( 'Widget', true )">All</button> <button (click)="updateAll( 'Widget', false )">None</button> Result: {{this.getValue(this.logWidgetValues) }}</span>
    </div>
  </div>
}
